import React, { useState, useEffect, useRef, useCallback } from "react";
import "./ListItem.css";
import ListImage from "../ListItemImage/ListItemImage";
import Commande from "../Commande/Commande";
import useApi from "../../hooks/useApi";
import BookingService from "../../services/booking.service";
import { castDate } from "../../shared/utils/string";
import useAuth from "../../hooks/useAuth";
import { Map } from './../google_map';
import { useTranslation } from 'react-i18next';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import IconButton from '@mui/material/IconButton';
import { Assignment } from "@mui/icons-material";
import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';
import { bindEvent, getPusher, initPusher } from "../../services/pusher.service";
import { formatClientNameWithCount, isNewClient, isVipClient } from "../../shared/utils/clientDisplay";

dayjs.extend(updateLocale);

dayjs.updateLocale('en', { weekStart: 1 });
dayjs.updateLocale('fr', { weekStart: 1 });




const ListItem = ({ date, time, title, description, status, bookingItem, t }) => {
  const client = bookingItem?.booking?.client;
  const labels = [
    isVipClient(client) ? t('table.vip') : null,
    isNewClient(client) ? t('table.newClientValue') : null,
  ].filter(Boolean);

  return <div className="item">
    <div className="item-content">
      <div className="date">
        <span>
          <span>{date}</span>
          <span> | </span>
          <span>{time}</span>
        </span>
      </div>
      <div className="item_title">{formatClientNameWithCount(client, title)}</div>
      {labels.length > 0 && <div className="item-client-flags">{labels.join(' | ')}</div>}
      <div className="item_description">{description}</div>
    </div>
    <div className="status-container">
      <div className="status-badge">
        <div className="status-label">{status}</div>
      </div>
    </div>
  </div>;
};

export default function List({ onItemSelect, handleItemSelect, onFlyproTransit, handleFlyproTransit, onInitialCoordinatesLoad, selectedFlyproFilter, date, onSkipCenterRefChange }) {
  const [activeTab, setActiveTab] = useState("Assigned");
  const [selectedItem, setSelectedItem] = useState(null);
  const [showCommande, setShowCommande] = useState(false);
  const api = useApi();
  const [bookings, setBookings] = useState([]);
  const [items, setItems] = useState([]);
  const commandeRef = useRef(null);
  const { auth } = useAuth();
  const userRoles = auth?.roles;
  const isHotelManager = userRoles?.some(role => role.name === "ROLE_HOTEL_MANAGER");
  const { i18n, t } = useTranslation(['dashboard']);
  const [showBlock, setShowBlock] = useState(false);
  const handleClickShowBlock = () => setShowBlock(!showBlock);
  const bookingsRefreshRef = useRef(null);
  const refreshInFlightRef = useRef(false);
  const lastRefreshRef = useRef(0);
  const skipCenterRef = useRef(false);
  // const [date, setDate] = useState(null);
  // const [open, setOpen] = useState(false);

  const fetchBookings = async () => {
    try {
      if (!userRoles?.some(role => role.name === "ROLE_ADMIN")) {
        const selectedDate = date;
        // const selectedDate = dayjs(date).isValid() ? dayjs(date).toDate() : new Date();
        const formatSelectedDate = selectedDate || new Date().toLocaleDateString('en-CA');
        let params = {
          with: 'therapists,therapists.media,products,products.category,creator,editor,client.primary_address,client_with_bookings_count,history,address,histories,histories.editor,histories.creator,hotel,transactions,client.ficheClient,hotel.ficheHotel,hotel.address',
          start_before: `contains:${formatSelectedDate}`,
          status: '!eq:failed_payment',
          created_by: `eq:${auth?.user?.id}`,
        }
        if (selectedFlyproFilter && selectedFlyproFilter !== '') {
          params.flypro_id = selectedFlyproFilter;
        }
        const response = await BookingService.index(params, api);
        const bookingsWithClientCount = response.map((booking) => ({
          ...booking,
          client: booking.client ? {
            ...booking.client,
            bookings_count: booking.client_with_bookings_count?.bookings_count,
          } : booking.client,
        }));
        const sortedResponse = bookingsWithClientCount.sort((a, b) =>
          new Date(a.date).getTime() - new Date(b.date).getTime()
        );
        setBookings(sortedResponse);
        const formattedBookings = sortedResponse.flatMap((booking) => {
          const bookingStatus = (booking.status === 'COMPLETED' || booking.status === 'CANCELED' || booking.status === 'FAILED') ? 'Terminé' :
            (booking.therapists.length ? 'Assigned' : 'Not Assigned');
          const bookingDate = new Date(booking.start_before);

          // Format date as DD/MM/YYYY
          const formattedDate = bookingDate.toLocaleDateString('en-GB');

          // Format start time
          const startTime = bookingDate.toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
          });

          // Calculate and format end time
          const endTime = new Date(bookingDate.getTime() + booking.duration * 60000).toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
          });

          const timeRange = `${startTime} - ${endTime}`;
          if (!booking.therapists.length) {
            // No therapists assigned
            return [{
              booking: booking,
              date: formattedDate,
              time: timeRange,
              title: booking?.client?.extra?.full_name,
              description: booking.description,
              status: bookingStatus,
              bstatus: booking.status,
            }];
          } else {
            return booking.therapists.map((therapist) => ({
              booking: booking,
              therapist: therapist,
              date: formattedDate,
              time: timeRange,
              title: booking?.client?.extra?.full_name,
              description: booking.description,
              status: bookingStatus,
              bstatus: booking.status,
            }));
          }
        });
        console.log({ response })
        console.log({ formattedBookings })
        setItems(formattedBookings);
        const allBookingCoords = formattedBookings.map(item => ({
          lat: item.booking?.address?.latitude,
          lng: item.booking?.address?.longitude,
          booking: item.booking,
        })).filter(coord => coord.lat && coord.lng);

        onInitialCoordinatesLoad?.(allBookingCoords, selectedDate, skipCenterRef.current);

        if (selectedItem) {
          const updatedItem = formattedBookings.find(item => item.booking.id === selectedItem.booking.id);
          console.log({ updatedItem });
          if (updatedItem) {
            setSelectedItem(updatedItem);
                onItemSelect(updatedItem.booking.address.latitude, updatedItem.booking.address.longitude, 10, updatedItem);
            onFlyproTransit(updatedItem.therapist.latitude, updatedItem.therapist.longitude, 10, updatedItem.bstatus, updatedItem.therapist);
          }
        }
      } else {
        // const selectedDate = dayjs(date).isValid() ? dayjs(date).toDate() : new Date();
        const selectedDate = date;
        const formatSelectedDate = selectedDate || new Date().toLocaleDateString('en-CA');
        let params = {
          with: 'therapists,therapists.media,products,products.category,creator,editor,client.primary_address,client_with_bookings_count,history,address,histories,histories.editor,histories.creator,hotel,transactions,client.ficheClient,hotel.ficheHotel,hotel.address',
          start_before: `contains:${formatSelectedDate}`,
          status: '!eq:failed_payment'
        }
        if (selectedFlyproFilter && selectedFlyproFilter !== '') {
          params.flypro_id = selectedFlyproFilter;
        }
        const response = await BookingService.index(params, api);

        const bookingsWithClientCount = response.map((booking) => ({
          ...booking,
          client: booking.client ? {
            ...booking.client,
            bookings_count: booking.client_with_bookings_count?.bookings_count,
          } : booking.client,
        }));
        const sortedResponse = bookingsWithClientCount.sort((a, b) =>
          new Date(a.date).getTime() - new Date(b.date).getTime()
        );
        setBookings(sortedResponse);
        const formattedBookings = sortedResponse.flatMap((booking) => {
          const bookingStatus = (booking.status === 'COMPLETED' || booking.status === 'CANCELED' || booking.status === 'FAILED') ? 'Terminé' :
            (booking.therapists.length ? 'Assigned' : 'Not Assigned');

          const bookingDate = new Date(booking.start_before);

          // Format date as DD/MM/YYYY
          const formattedDate = bookingDate.toLocaleDateString('en-GB');

          // Format start time
          const startTime = bookingDate.toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            timeZone: 'Europe/Zurich'
          });

          // Calculate and format end time
          const endTime = new Date(bookingDate.getTime() + booking.duration * 60000).toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            timeZone: 'Europe/Zurich'
          });

          const timeRange = `${startTime} - ${endTime}`;

          if (!booking.therapists.length) {
            // No therapists assigned
            return [{
              booking: booking,
              date: formattedDate,
              time: timeRange,
              title: booking?.client?.extra?.full_name,
              description: booking.description,
              status: bookingStatus,
              bstatus: booking.status,
            }];
          } else {
            return booking.therapists.map((therapist) => ({
              booking: booking,
              therapist: therapist,
              date: formattedDate,
              time: timeRange,
              title: booking?.client?.extra?.full_name,
              description: booking.description,
              bstatus: booking.status,
              status: bookingStatus,
            }));
          }
        });
        console.log({ response })
        console.log({ formattedBookings })
        setItems(formattedBookings);
        const allBookingCoords = formattedBookings.map(item => ({
          lat: item.booking?.address?.latitude,
          lng: item.booking?.address?.longitude,
          booking: item.booking,
        })).filter(coord => coord.lat && coord.lng);

        onInitialCoordinatesLoad?.(allBookingCoords, selectedDate, skipCenterRef.current);

        if (selectedItem) {
          const updatedItem = formattedBookings.find(item => item.booking.id === selectedItem.booking.id);
          console.log({ updatedItem });
          if (updatedItem) {
            setSelectedItem(updatedItem);
                onItemSelect(updatedItem.booking.address.latitude, updatedItem.booking.address.longitude, 10, updatedItem);
            onFlyproTransit(updatedItem.therapist.latitude, updatedItem.therapist.longitude, 10, updatedItem.bstatus, updatedItem.therapist);
          }
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const scheduleBookingsRefresh = useCallback(() => {
    if (!bookingsRefreshRef.current) {
      return;
    }

    if (refreshInFlightRef.current) {
      return;
    }

    const now = Date.now();
    if (now - lastRefreshRef.current < 1500) {
      return;
    }

    lastRefreshRef.current = now;
    refreshInFlightRef.current = true;
    skipCenterRef.current = true;
    console.log({ skipCenterRef: skipCenterRef.current });


    Promise.resolve(bookingsRefreshRef.current())
      .catch((error) => {
        console.error("Realtime booking refresh failed:", error);
      })
      .finally(() => {
        refreshInFlightRef.current = false;
        skipCenterRef.current = false;
      });
  }, []);

  useEffect(() => {
    fetchBookings();
  }, [date, selectedFlyproFilter]);

  useEffect(() => {
    if (onSkipCenterRefChange && skipCenterRef.current) {
      onSkipCenterRefChange(skipCenterRef.current);
      console.log({ skipCenterRef: skipCenterRef.current });
    }
  }, [skipCenterRef.current]);

  useEffect(() => {
    bookingsRefreshRef.current = fetchBookings;
  }, [fetchBookings, date, selectedFlyproFilter, auth?.user?.id]);

  useEffect(() => {
    if (!auth?.accessToken) return;

    initPusher({ token: auth?.accessToken });

    const handler = (data) => {
      const payload =
        typeof data === "string"
          ? (() => {
              try {
                return JSON.parse(data);
              } catch (_) {
                return {};
              }
            })()
          : data || {};

      if (isHotelManager) {
        const hotelId = auth?.user?.hotel?.[0]?.id;
        if (hotelId && payload?.hotel_id && Number(payload.hotel_id) !== Number(hotelId)) {
          return;
        }
      }

      scheduleBookingsRefresh();
    };

    const publicHandler = (data) => {
      const envelope =
        typeof data === "string"
          ? (() => {
              try {
                return JSON.parse(data);
              } catch (_) {
                return {};
              }
            })()
          : data || {};

      if (envelope?.key !== "dashboard.bookings") {
        return;
      }

      const payload = envelope?.payload || {};

      if (isHotelManager) {
        const hotelId = auth?.user?.hotel?.[0]?.id;
        if (
          hotelId &&
          payload?.hotel_id &&
          Number(payload.hotel_id) !== Number(hotelId)
        ) {
          return;
        }
      }

      scheduleBookingsRefresh();
    };

    const unbindPrivate = bindEvent(
      "private-admin-dashboard",
      "dashboard.bookings.updated",
      handler
    );

    const unbindPublic = bindEvent(
      "public-data",
      "realtime.data.updated",
      publicHandler
    );

    return () => {
      unbindPrivate();
      unbindPublic();
    };
  }, [auth?.accessToken, auth?.user?.hotel, isHotelManager, scheduleBookingsRefresh]);

  useEffect(() => {
    if (!auth?.accessToken) return;

    initPusher({ token: auth?.accessToken });
    const pusher = getPusher();
    if (!pusher) return;

    const handleConnected = () => {
      scheduleBookingsRefresh();
    };

    pusher.connection.bind("connected", handleConnected);

    return () => {
      pusher.connection.unbind("connected", handleConnected);
    };
  }, [auth?.accessToken, scheduleBookingsRefresh]);

  useEffect(() => {
    const handleOnline = () => {
      scheduleBookingsRefresh();
    };

    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("online", handleOnline);
    };
  }, [scheduleBookingsRefresh]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isMuiComponent =
        event.target.closest('.MuiMenu-paper') !== null ||
        event.target.closest('.MuiPopover-root') !== null ||
        event.target.closest('.MuiModal-root') !== null ||
        event.target.closest('.MuiDialog-paper') !== null ||
        event.target.closest('[role="menu"]') !== null ||
        event.target.closest('[role="dialog"]') !== null;

      if (commandeRef.current &&
        !commandeRef.current.contains(event.target) &&
        !isMuiComponent) {
        setShowCommande(false);
      }
    };

    if (showCommande) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCommande]);

  const filteredItems = items.filter((item) => item.status === activeTab);
  const locale = i18n.language === 'fr' ? 'fr' : 'en';

  return (
    <>
      {showBlock ? (
        <div className="list-item-with-image" style={{ height: 'unset' }} onClick={handleClickShowBlock}>
          <Assignment sx={{ fontSize: 40 }} />
        </div>
      ) : (
        <div className="list-item-with-image">
          <div className="frame-14" onClick={handleClickShowBlock}>
            <div className="title">{t('orders')}</div>
            {/* <div className="glyph" /> */}
            {/* <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
          <DatePicker
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            value={date}
            onChange={(newValue) => {
              setDate(newValue);
              setOpen(false);
            }}
            slots={{
              textField: () => (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                  }}
                >
                  {date && (
                    <span
                      style={{
                        fontSize: '0.9rem',
                        color: '#333',
                      }}
                    >
                      {dayjs(date)
                        .locale(i18n.language === 'fr' ? 'fr' : 'en')
                        .format('MMM D, YYYY')}
                    </span>
                  )}
                  <IconButton
                    onClick={() => setOpen(true)}
                    size="small"
                    sx={{
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      backgroundColor: '#fff',
                      width: 36,
                      height: 36,
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                      '&:hover': {
                        backgroundColor: '#f5f5f5',
                      },
                    }}
                  >
                    <CalendarTodayIcon fontSize="small" color="action" />
                  </IconButton>
                </div>
              ),
            }}
          />
        </LocalizationProvider> */}
          </div>
          <div className="tabs">
            <div className="tab-group">
              <div
                className={`tab-1 ${activeTab === "Not Assigned" ? "active" : ""}`}
                onClick={() => setActiveTab("Not Assigned")}
              >
                <div className="state-layer">
                  <div className="tab-contents">
                    <div className="label2"><span className="tab-count">
                      ({items.filter(item => item.status === "Not Assigned").length})
                    </span>{t('tabs.notAssigned')}</div>
                    {activeTab === "Not Assigned" && (
                      <div className="indicator">
                        <div className="shape"></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div
                className={`tab-2 ${activeTab === "Assigned" ? "active" : ""}`}
                onClick={() => setActiveTab("Assigned")}
              >
                <div className="state-layer">
                  <div className="tab-contents">
                    <div className="label2"><span className="tab-count">
                      ({items.filter(item => item.status === "Assigned").length})
                    </span>{t('tabs.assigned')}</div>
                    {activeTab === "Assigned" && (
                      <div className="indicator">
                        <div className="shape"></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div
                className={`tab-3 ${activeTab === "Terminé" ? "active" : ""}`}
                onClick={() => setActiveTab("Terminé")}
              >
                <div className="state-layer">
                  <div className="tab-contents">
                    <div className="label2"><span className="tab-count">
                      ({items.filter(item => item.status === "Terminé").length})
                    </span>{t('tabs.completed')}</div>
                    {activeTab === "Terminé" && (
                      <div className="indicator">
                        <div className="shape"></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {activeTab === "Not Assigned" && (
            <div className="list-items">
              {filteredItems.map((item, index) => (
                <ListItem
                  key={index}
                  bookingItem={item}
                  date={item.date}
                  time={item.time}
                  title={item.title}
                  description={item.description}
                  status={item.status}
                  bstatus={item.bstatus}
                  t={t}
                />
              ))}
            </div>
          )}
          {activeTab === "Assigned" && (
            <div className="list-items">
              {filteredItems.map((item, index) => (
                <div
                  className={`list-item-container ${selectedItem?.booking?.id === item.booking.id ? "highlighted" : ""}`}
                  key={index}
                  onClick={() => {
                    setSelectedItem(item);
                    setShowCommande(true);
                    console.log("Item clicked", item); // Log the clicked item data to verify
                    onItemSelect(item.booking.address.latitude, item.booking.address.longitude, 10, item.booking);
                    onFlyproTransit(item.therapist.latitude, item.therapist.longitude, 10, item.bstatus, item.therapist);
                  }}
                >
                  <ListImage
                    bookingItem={item}
                    date={item.date}
                    time={item.time}
                    title={item.title}
                    description={item.description}
                    status={item.status}
                    bstatus={item.bstatus}
                    onItemSelect={() => handleItemSelect(item.booking.address.latitude, item.booking.address.longitude, 10, item.booking)}
                    onFlyproTransit={() => handleFlyproTransit(item.therapist.latitude, item.therapist.longitude, 10, item.bstatus, item.therapist)}
                  />
                </div>
              ))}
            </div>
          )}

          {activeTab === "Terminé" && (
            <div className="list-items">
              {filteredItems.map((item, index) => (
                <div
                  className={`list-item-container ${selectedItem?.booking?.id === item.booking.id ? "highlighted" : ""}`}
                  key={index}
                  onClick={() => {
                    setSelectedItem(item);
                    setShowCommande(true);
                    console.log("Item clicked", item); // Log the clicked item data to verify
                    onItemSelect(item.booking.address.latitude, item.booking.address.longitude, 10, item.booking);
                  }}
                >
                  <ListImage
                    bookingItem={item}
                    date={item.date}
                    time={item.time}
                    title={item.title}
                    description={item.description}
                    status={item.status}
                    bstatus={item.bstatus}
                    onItemSelect={() => handleItemSelect(item.booking.address.latitude, item.booking.address.longitude, 10, item.booking)}
                  />
                </div>
              ))}
            </div>
          )}

          {showCommande && selectedItem && (
            <div className="commande-container" ref={commandeRef} >
              <Commande selectedItem={selectedItem} api={api} fetchBookings={fetchBookings} />
            </div>
          )}
        </div>
      )}
    </>
  );
}
